export const NotFound = () => {
  return (
    <div className="container-lg mt-5 text-center">
      <p>There was a problem fetching the page you requested. <br/>If refreshing does not solve the problem, please contact <a href="mailto:support@fieldfactsbaseball.com">support</a>.</p>
      <p><a href="/">Go Back</a></p>
    </div>
  );
}